import { api } from '../api';

const unwrap = (r) => r?.data ?? r;

export default {
  dncCheck:      (body) => api.post('/v1/compliance/dnc/check', body).then(r => r.data),
  recordConsent: (body) => api.post('/v1/compliance/consent', body).then(r => r.data),
  handleStop:    (body) => api.post('/v1/compliance/consent/handle-stop', body).then(r => r.data),
  auditLog:      (params) => api.get('/v1/compliance/audit', { params }).then(r => unwrap(r.data)),
  summary:       (params) => api.get('/v1/compliance/summary', { params }).then(r => unwrap(r.data)),
};
